import { TeamMemberBillingResponse } from '@/modules/team/types/dto/response/team-member-billing-response';
import { InternalRateType, TeamMember } from '@/modules/team/types/team-member';

/**
 * Maps team member billing response to domain model fields
 * Converts isHourlyRated boolean to InternalRateType enum
 */
export const mapTeamMemberBillingFromResponse = (
  response: TeamMemberBillingResponse
): Partial<TeamMember> => {
  // Convert isHourlyRated to InternalRateType enum
  const internalRateType = response.isHourlyRated
    ? InternalRateType.HourlyCostRate
    : InternalRateType.MonthlySalary;

  return {
    internalRateType,
    internalRateCurrency: response.internalRateCurrency.code,
    internalRate: response.internalRate ?? 0,
    externalHourlyRate: response.externalRate ?? 0,
  };
};
